import React from "react";
import * as analysisService from "../../services/kyc/account-analysis-service";
import { Authorize } from "../../components/authorize";
import * as Loader from "../../common/common";
import TextBox from "../../components/form-controls/textbox";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import { withRouterProps } from "../../common/hocs";

class SupplierAnalysis extends Authorize {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
  }
  state = {
    clientId: this.props.clientId,
    userType: this.props.clientType,
    SupplierAnalysis: {
      clientId: "",
      division: "",
      services: "",
      vehicle: "",
      depemp: "",
      tds: "",
      gstStAnalysisCode: "",
      custSupp: "",
      misc: "",
      vendorRelation: "",
      vendorStatus: "",
    },
    validationErrors: {
      clientIdError: "",
      divisionError: "",
      servicesError: "",
      vehicleError: "",
      depempError: "",
      tdsError: "",
      gstStAnalysisCodeError: "",
      custSuppError: "",
      miscError: "",
      vendorRelationError: "",
      vendorStatusError: "",
    },
    error: "",
    msg: "",
  };

  async downloadPdf(clientId) {
    let data = {
      clientId: clientId,
    };
    let {
      response,
      err,
    } = await commonDownloadPdfService.downloadSupplierAnalysis(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "SupplierAnalysis_" + clientId);
    }
  }

  componentDidMount() {
    this.getSupplierAnalysis();
  }
  async getSupplierAnalysis() {
    Loader.showLoader();
    let { response, err } = await analysisService.getSupplierAnalysis({
      data: this.state.clientId,
    });
    Loader.hideLoader();
    if (err) {
      this.setState({
        error: err,
        msg: "",
      });
    } else if (response.data && response.data.err) {
      this.setState({
        error: response.data.err,
        msg: "",
      });
    } else {
      if (response.data) {
        this.setState({
          SupplierAnalysis: response.data,
        });
      }
    }
  }
  onChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    if (name === "gstStAnalysisCode") {
      this.setState({
        SupplierAnalysis: {
          ...this.state.SupplierAnalysis,
          [name]: value.toUpperCase(),
        },
      });
    } else {
      this.setState({
        SupplierAnalysis: {
          ...this.state.SupplierAnalysis,
          [name]: value,
        },
      });
    }
  }

  async onSubmit(v, e) {
    Loader.showLoader();
    if (!e) {
      e = v;
    }
    e.preventDefault();
    if (v && v === "prev") {
      this.props.router.navigate(
        "/kycs/" +
          this.state.clientId +
          "/" +
          this.state.userType +
          "/transactionanalysis"
      );
    } else {
      let {
        division,
        services,
        vehicle,
        tds,
        gstStAnalysisCode,
        custSupp,
        misc,
        vendorRelation,
        vendorStatus,
      } = this.state.SupplierAnalysis;

      var data = Object.assign({}, this.state.SupplierAnalysis);
      data.clientId = this.state.clientId;
      data.division = division === undefined ? division : division.trim();
      data.services = services === undefined ? services : services.trim();
      data.vehicle = vehicle === undefined ? vehicle : vehicle.trim();
      data.tds = tds === undefined ? tds : tds.trim();
      data.gstStAnalysisCode =
        gstStAnalysisCode === undefined
          ? gstStAnalysisCode
          : gstStAnalysisCode.trim();
      data.custSupp = custSupp === undefined ? custSupp : custSupp.trim();
      data.misc = misc === undefined ? misc : misc.trim();
      data.vendorRelation =
        vendorRelation === undefined ? vendorRelation : vendorRelation.trim();
      data.vendorStatus =
        vendorStatus === undefined ? vendorStatus : vendorStatus.trim();
      let { response, err } = await analysisService.saveSupplierAnalysis(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
      } else {
        this.setState({
          SupplierAnalysis: data,
          msg: response.data.msg,
          error: response.data.err,
        });
      }
    }
  }
  onClear() {
    this.setState({
      SupplierAnalysis: {
        division: "",
        services: "",
        vehicle: "",
        depemp: "",
        tds: "",
        gstStAnalysisCode: "",
        custSupp: "",
        misc: "",
        vendorRelation: "",
        vendorStatus: "",
      },
      validationErrors: {},
      error: "",
      msg: "",
    });
  }
  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let {
      division,
      services,
      vehicle,
      depemp,
      tds,
      gstStAnalysisCode,
      custSupp,
      misc,
      vendorRelation,
      vendorStatus,
    } = this.state.SupplierAnalysis;
    let {
      divisionError,
      servicesError,
      vehicleError,
      depempError,
      tdsError,
      gstStAnalysisCodeError,
      custSuppError,
      miscError,
      vendorRelationError,
      vendorStatusError,
    } = this.state.validationErrors;
    return (
      <React.Fragment>
        <div className="container">
          <a
            title="Download PDF"
            onClick={this.downloadPdf.bind(this, this.state.clientId)}
          >
            <img
              style={{ height: "30px" }}
              src="/images/pdf.png"
              alt="Download PDF"
            ></img>
          </a>
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="card-body p-4">
                <form onSubmit={this.onSubmit}>
                  <div>&nbsp;</div>
                  {this.state.msg ? (
                    <p className="alert alert-success">{this.state.msg}</p>
                  ) : null}
                  {this.state.error ? (
                    <p className="alert alert-error">{this.state.error}</p>
                  ) : null}
                  <div className="row">
                    <div className="col-sm-6">
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="division"
                        label="Division"
                        value={division || ""}
                        maxLength="300"
                        error={divisionError}
                        onChange={this.onChange}
                      />
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="services"
                        label="Services"
                        value={services || ""}
                        maxLength="300"
                        error={servicesError}
                        onChange={this.onChange}
                      />
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="vehicle"
                        label="Vehicle"
                        value={vehicle || ""}
                        maxLength="300"
                        error={vehicleError}
                        onChange={this.onChange}
                      />
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="depemp"
                        label="Dep/Emp"
                        value={depemp || ""}
                        maxLength="150"
                        error={depempError}
                        onChange={this.onChange}
                      />
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="tds"
                        label="TDS"
                        value={tds || ""}
                        maxLength="300"
                        error={tdsError}
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="col-sm-6">
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="gstStAnalysisCode"
                        label="GST/ST Analysis"
                        value={gstStAnalysisCode || ""}
                        maxLength="300"
                        error={gstStAnalysisCodeError}
                        onChange={this.onChange}
                      />
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="custSupp"
                        label="Customer/Supplier"
                        value={custSupp || ""}
                        maxLength="300"
                        error={custSuppError}
                        onChange={this.onChange}
                      />

                      <div className="form-group">
                        <TextBox
                          type="text"
                          animatedClass="fg-animate"
                          name="misc"
                          label="Miscellaneous"
                          value={misc || ""}
                          maxLength="300"
                          error={miscError}
                          onChange={this.onChange}
                        />
                      </div>
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="vendorRelation"
                        label="Vendor Relation"
                        value={vendorRelation || ""}
                        maxLength="150"
                        error={vendorRelationError}
                        onChange={this.onChange}
                      />
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        name="vendorStatus"
                        label="Vendor Status"
                        value={vendorStatus || ""}
                        maxLength="300"
                        error={vendorStatusError}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <button
                      className="btn btn-md btn-primary"
                      type="button"
                      onClick={this.onSubmit.bind(this, "prev")}
                    >
                      Previous
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-md btn-primary"
                      type="submit"
                      onClick={this.onSubmit}
                    >
                      Save
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-md btn-primary"
                      type="button"
                      onClick={this.onClear}
                    >
                      Clear
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(SupplierAnalysis);